<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="merchantId" >
        <span slot="label" ><a-tooltip>{{$t('商家id')}}<template slot="title">{{$t('商家id')}}</template></a-tooltip> </span>
              <a-input-number v-model="form.merchantId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'商家id'" />
      </a-form-model-item>
      <a-form-model-item prop="storeId" >
        <span slot="label" ><a-tooltip>{{$t('门店id')}}<template slot="title">{{$t('门店id')}}</template></a-tooltip> </span>
              <a-input-number v-model="form.storeId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'门店id'" />
      </a-form-model-item>
      <a-form-model-item prop="goodsId" >
        <span slot="label" ><a-tooltip>{{$t('商品编号')}}<template slot="title">{{$t('商品编号')}}</template></a-tooltip> </span>
              <a-input-number v-model="form.goodsId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'商品编号'" />
      </a-form-model-item>
      <a-form-model-item prop="status" >
        <span slot="label" ><a-tooltip>{{$t('商品状态 0下架，1正常')}}<template slot="title">{{$t('商品状态 0下架，1正常')}}</template></a-tooltip> </span>
      </a-form-model-item>
      <a-form-model-item prop="stock" >
        <span slot="label" ><a-tooltip>{{$t('库存')}}<template slot="title">{{$t('库存')}}</template></a-tooltip> </span>
              <a-input-number v-model="form.stock" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'库存'" />
      </a-form-model-item>
      <a-form-model-item prop="salesNum" >
        <span slot="label" ><a-tooltip>{{$t('销售数量')}}<template slot="title">{{$t('销售数量')}}</template></a-tooltip> </span>
              <a-input-number v-model="form.salesNum" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'销售数量'" />
      </a-form-model-item>
      <a-form-model-item prop="deptId" >
        <span slot="label" ><a-tooltip>{{$t('部门id')}}<template slot="title">{{$t('部门id')}}</template></a-tooltip> </span>
              <a-input-number v-model="form.deptId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'部门id'" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getGoodsStore, addGoodsStore, updateGoodsStore } from '@/api/goods/goodsStore'
  import {mapGetters} from 'vuex'
  import CustomDictTag from "@/components/DictCustomTag";
  import {generateFilePath, uploadObject} from "@/api/tool/oss";
  import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";
  import moment from 'moment';


  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        merchantId: null,
        storeId: null,
        goodsId: null,
        status: 0,
        stock: null,
        salesNum: null,
        deptId: null,
        localeFieldMap:{},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
          merchantId: [{ required: true, message: this.$t('商家id')+this.$t('不能为空'), trigger: 'blur' }] ,
          storeId: [{ required: true, message: this.$t('门店id')+this.$t('不能为空'), trigger: 'blur' }] ,
          goodsId: [{ required: true, message: this.$t('商品编号')+this.$t('不能为空'), trigger: 'blur' }] ,
          stock: [{ required: true, message: this.$t('库存')+this.$t('不能为空'), trigger: 'blur' }] ,
          salesNum: [{ required: true, message: this.$t('销售数量')+this.$t('不能为空'), trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    moment,
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        merchantId: null,
        storeId: null,
        goodsId: null,
        status: 0,
        stock: null,
        salesNum: null,
        deptId: null,
        localeFieldMap:{},
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getGoodsStore({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateGoodsStore(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addGoodsStore(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
